import ComponentDetailsDashboard from "./dashboard";
export default ComponentDetailsDashboard;
